import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'

export const routes = [
  {
    path: '/credit-cards',
    name: 'credit-cards',
    components: {
      default: () => import('./credit-cards.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    },
    meta: {
      sitemap: {
        title: 'Credit cards',
        description: 'Compare business credit card options (UK)',
        conditions: {
          all: [
            { fact: 'global', path: '$.countryCode', operator: 'equal', value: 'GB' },
            { fact: 'additionalProducts', path: '$.enableCreditCardPage', operator: 'equal', value: true }
          ]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
